import { ORDER_STATUS } from '@vindr/services/constants/order.constant';
import { ActionIcon } from '@vindr/ui';
import { formatDateColumn } from '@vindr/utils/dateTime';
import { TableColumnsType } from 'antd';
import { useTranslation } from 'react-i18next';

const useOrderColumns = ({ sorter = true, onRemove }): TableColumnsType<any> => {
  const { t } = useTranslation('Vindoc');

  return [
    {
      title: '#',
      width: 40,
      dataIndex: 'id',
      key: 'id',
      ellipsis: true,
      render: (_, __, index) => index + 1,
    },
    {
      title: t('Status'),
      width: 100,
      dataIndex: 'status',
      key: 'status',
      ellipsis: true,
      sorter: sorter,
      render: (status) => t(ORDER_STATUS[status]),
    },
    {
      title: t('Order Group'),
      width: 110,
      dataIndex: 'order_group',
      key: 'order_group',
      ellipsis: true,
      sorter: sorter,
    },
    {
      title: t('Scheduled Date'),
      width: 110,
      dataIndex: 'scheduled_date',
      key: 'scheduled_date',
      ellipsis: true,
      sorter: sorter,
      render: (text) => formatDateColumn(text),
    },
    {
      title: t('Study Description'),
      width: 200,
      dataIndex: ['procedure', 'name'],
      key: 'study_desc',
      ellipsis: true,
      sorter: sorter,
    },
    {
      title: t('Actions'),
      dataIndex: 'operation',
      key: 'operation',
      align: 'center',
      width: 80,
      fixed: 'right',
      render: (text, record) => {
        return (
          <ActionIcon>
            <ActionIcon.Delete onClick={() => onRemove(record)} />
          </ActionIcon>
        );
      },
    },
  ];
};

export default useOrderColumns;
